module.exports = __webpack_public_path__ + "img/blue_136.dec12a1e.png";